/** @jsx jsx */
import { css, jsx } from '@compiled/react';
import Markdown from 'markdown-to-jsx';
import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import { Box, Flex, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import IphoneBlackDelete from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/devices/components/iphone-black-delete';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import taskMessages from '../../../../common/utils/tasks/messages';
import messages from './messages';

const BlueText = ({ children }: { children: React.ReactNode }) => (
	<Text color="color.link">{children}</Text>
);

export const CardZero = () => {
	const { formatMessage } = useIntl();
	return (
		<Inline grow="fill" alignInline="center" alignBlock="center" xcss={wrapperInlineStyles}>
			<Box padding="space.300">
				<Stack space="space.200" alignInline="start">
					<Heading as="h2" size="small">
						<FormattedMessage {...taskMessages.notificationsTaskOneNonFinal} />
					</Heading>
					<Box>
						<Markdown options={{ overrides: { BlueText: { component: BlueText } } }}>
							{formatMessage(messages.descriptionNonFinal)}
						</Markdown>
					</Box>
					<Button href="/jira/settings/personal/alert-notifications" target="_blank">
						{formatMessage(messages.manageYourAlertNotificationsNonFinal)}
					</Button>
				</Stack>
			</Box>
			<Box xcss={illustrationWrapperBoxStyles}>
				<Flex xcss={iphoneContainerStyles} alignItems="center" justifyContent="end">
					<div css={iphoneStyles}>
						<IphoneBlackDelete width={154} alt="" />
					</div>
				</Flex>
			</Box>
		</Inline>
	);
};

const iphoneContainerStyles = xcss({
	overflow: 'hidden',
});

const iphoneStyles = css({
	transform: 'rotate(-25.264deg)',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingTop: '25.265px',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingLeft: '25.265px',
});

const illustrationWrapperBoxStyles = xcss({
	alignSelf: 'end',
	width: '320px',
	flexShrink: 0,
});

const wrapperInlineStyles = xcss({
	boxShadow: 'elevation.shadow.raised',
	borderRadius: 'border.radius.200',
});
